const getThrottledValue = value => {
	if (value < 320) {
		return 320;
	}
	if (value >= 320 && value < 580) {
		return 580;
	}
	if (value >= 580 && value < 768) {
		return 768;
	}
	if (value >= 768 && value < 1024) {
		return 1024;
	}
	if (value >= 1024 && value < 1280) {
		return 1280;
	}
	if (value >= 1280 && value < 1440) {
		return 1440;
	}
	if (value >= 1440 && value < 1760) {
		return 1760;
	}
	if (value >= 1760 && value < 1920) {
		return 1920;
	}
	if (value >= 1920 && value < 2560) {
		return 2560;
	}
	if (value >= 2560) {
		return 4000;
	}

	return 0;
};

export const getThrottledWidthAndHeight = (width: number, height: number) => {
	return { width: getThrottledValue(width), height: getThrottledValue(height) };
};
